import api from "./api";

const requestPreSignedUrlAws = async (tipoPermissao, s3Action, bucketName, caminhoArquivo, filename, disposition = "attachment") => {
    const body = {
        tipoPermissao: tipoPermissao,
        s3Action: s3Action,
        bucket: bucketName,
        objectKey: caminhoArquivo,
        filename: filename,
        disposition: disposition,
    };

    try {
        const response = await api.post('/presigned-url', body, {
            headers: { "x-s3-access-level": tipoPermissao },
        });
        if (response.status === 200) {
            return response.data.url;
        } else {
            console.log("Falha ao solicitar acesso ao arquivo na nuvem.");
            throw new Error("Falha ao solicitar acesso ao arquivo na nuvem.");
        }
    } catch (error) {
        console.log(error);
        return error;
    }
}

export default requestPreSignedUrlAws